export * from './nlg.actions'
export * from './relativePerformance.actions'
export * from './nlgPeers.actions'

export const FETCHING = 'FETCHING'
export const IDLE = 'IDLE'
export const FETCHED = 'FETCHED'
export const FAILED = 'FAILED'
